export default {
  label: {
    man: 'Hombre',
    woman: 'Mujer',
    office: 'Organización',
    notClassified: 'No Clasificados',
  },
};
